/* globals jQuery, grecaptcha, GRECAPTCHA_CONFIG */

import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupFocusTrap from './theme/focus-trap';
import setupAccordions from './theme/accordions';
import setupCarousels from './theme/carousels';
import setupModals from './theme/modals';

jQuery( $ => {
	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$document
		.on( 'touchstart', function() {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', function() {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', function() {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Basic Toggles
	// =========================

	$body.on( 'click', '.js-toggle', function( event ) {
		const target = determineTarget( this );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, this.getAttribute( 'aria-expanded' ) !== 'true' );

			// For global styling that might be needed
			$body.toggleClass( `show-${ target.id }`, isOpen );

			// For additional actions during open/close
			$body.trigger( `toggle:${ target.id }:${ isOpen ? 'on' : 'off' }` );
		}
	} );

	// =========================
	// ! Nav Focus Trap
	// =========================

	$( '[role="navigation"]' ).each( function() {
		// trap focus to items and controlling toggles
		const $items = $( this ).find( 'a, button' ).add( `[aria-controls="${ this.id }"]` );
		$( this ).attr( 'tabindex', -1 );

		setupFocusTrap( this, $items.get() );
	} );

	$( '#navigation a' ).click( function() {
		toggleElement( 'navigation', false );
	} );

	// =========================
	// ! Accordion
	// =========================

	// Group adjacent accordions
	$( '.bousfields-accordion' ).each( function() {
		let $group = $( this ).prev( '.bousfields-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="bousfields-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );

	// Add classes to accordion blocks automatically
	$( '.bousfields-accordion-group' ).addClass( 'js-accordion-group' );
	$( '.bousfields-accordion' ).addClass( 'js-accordion' );
	$( '.bousfields-accordion__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.bousfields-accordion__content' ).addClass( 'js-accordion-content' );

	setupAccordions();

	// =========================
	// ! Gallery Carousel
	// =========================

	// Prep carousel galleries for functionality
	$( '.bousfields-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.wp-block-gallery' ).addClass( 'js-carousel-track' );
		$( this ).find( '.wp-block-image' ).addClass( 'js-carousel-slide' );
	} );

	setupCarousels( { animate: true } );

	// =========================
	// ! Contact Form Submission
	// =========================

	let withRecaptcha = function( data, callback ) {
		callback( data );
	};

	if ( typeof grecaptcha !== 'undefined' && typeof GRECAPTCHA_CONFIG !== 'undefined' ) {
		grecaptcha.ready( () => {
			withRecaptcha = function( data, callback ) {
				grecaptcha.execute( GRECAPTCHA_CONFIG.siteKey, { action: 'homepage' } )
					.then( token => {
						if ( typeof data === 'object' ) {
							data.grecaptcha = token;
						} else {
							data += '&grecaptcha=' + token;
						}
						callback( data );
					} );
			};
		} );
	}

	$( '.bousfields-form' ).submit( function( e ) {
		e.preventDefault();
		const $form = $( this );
		withRecaptcha(
			$( this ).serialize(),
			data => {
				$form.find( '.feedback' ).remove();
				const $feedback = $( '<p class="feedback"></p>' );

				$.ajax( {
					url: this.action,
					method: this.method,
					data,
					dataType: 'json',
					success( response ) {
						if ( response.ok ) {
							$form.after( $feedback.text( response.message ) );
							$form.remove();
							return;
						}

						/* eslint-disable-next-line no-alert */
						alert( 'Unknown error, please try again.' );
						/* eslint-disable-next-line no-console */
						console.log( response );
					},
					error( { responseText, responseJSON } ) {
						if ( ! responseJSON ) {
							/* eslint-disable-next-line no-alert */
							alert( 'Unknown error, please try again.' );
							/* eslint-disable-next-line no-console */
							console.log( responseText );
						}

						if ( responseJSON.message ) {
							$form.append( $feedback.text( responseJSON.message ) );
						}
					},
				} );
			},
		);
	} );

	// =========================
	// ! Image Fullscreen Support
	// =========================

	$( '.wp-block-gallery .wp-block-image, .wp-block-image.expandable' ).each( function( index ) {
		const img = this.querySelector( 'img' );
		const takeoverId = `takeover-${ index + 1 }`;

		const takeover = document.createElement( 'figure' );
		takeover.id = takeoverId;
		takeover.classList.add( 'bousfields-takeover' );
		takeover.classList.add( 'js-modal' );

		const expand = document.createElement( 'button' );
		expand.type = 'button';
		expand.classList.add( 'bousfields-toggle' );
		expand.setAttribute( 'aria-controls', takeoverId );
		expand.innerText = 'View Full Size';

		const collapse = document.createElement( 'button' );
		collapse.type = 'button';
		collapse.classList.add( 'bousfields-toggle' );
		collapse.classList.add( 'js-modal-close' );
		collapse.innerText = 'Close';

		this.append( expand );
		takeover.append( collapse );
		takeover.append( img.cloneNode() );
		document.body.append( takeover );
	} );

	setupModals();

	// =========================
	// ! VH Hack
	// =========================

	function setVH() {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
	}

	window.addEventListener( 'resize', setVH );
	setVH();

	// =========================
	// ! Initialize Stuff
	// =========================

	// Open accordions marked auto-open
	$( '.js-accordion.auto-open' ).addClass( 'is-active' ).find( '.js-accordion-content' ).first().addClass( 'is-open' );

	// Open first tab in a set
	$( '.js-tab-set' ).each( function() {
		$( this ).find( '.js-tab-trigger' ).first().addClass( 'is-active' );
		$( this ).find( '.js-tab' ).first().addClass( 'is-open' );
	} );
} );
